module.exports = __webpack_public_path__ + "img/collection-weddingRingsWomen.8680e70.jpg";